module.exports = __webpack_public_path__ + "img/4.8ffa090a.png";